// extracted by mini-css-extract-plugin
export var dropdown = "_rg-0";
export var imageWrapper = "_rg-3";
export var itemNameContainer = "_rg-1";
export var productImage = "_rg-2";
export var spinnerWrapper = "_rg-4";